import React from 'react';
import PropTypes from 'prop-types';
import {Field, reduxForm} from 'redux-form';

const validate = (values) => {
    const errors = {};

    if (!values.login) {
        errors.login = 'Vaaditaan';
    }

    return errors;
};

const renderField = ({input, label, placeholder, type, value, meta: {touched, error}}) => (
  <div className='form-group'>
    <label className='upper-label'>{label}</label>
    <input {...input} type={type} placeholder={placeholder} value={value}
      className={touched && error && 'form-control is-invalid'
           || touched && 'form-control is-valid' || 'form-control'}/>
  </div>
);

const PasswordResetForm = props => {
  const { handleSubmit, resetPassword } = props;

  return (
    <div className='wrapper'>
      <form className='form-reset-password' onSubmit={handleSubmit(resetPassword)}>
        <h2 className='form-reset-password-header'>Salasanan uudelleenasettaminen</h2>
        <Field name='login' label='Käyttäjätunnus' type='text' component={renderField} placeholder='Käyttäjätunnus'/>
        <button className='btn btn-primary btn-lg col-lg-12' type='submit'>
          <span className='btn-text'>Uudelleenaseta salasana</span>
        </button>
      </form>
    </div>
  )
};

PasswordResetForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    fields: PropTypes.object.isRequired,
    resetPassword: PropTypes.func.isRequired
};

export default reduxForm({
    form: 'passwordResetForm',
    validate
})(PasswordResetForm);



// WEBPACK FOOTER //
// ./src/components/PasswordResetForm.js